import { Box, Button, Chip, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as PlayIcon } from "Assets/Icons/Classroom/PlayIcon.svg";
import { ReactComponent as SolutionIcon } from "Assets/Icons/Classroom/SolutionIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Warning from "Components/Common/Warning";
import CompleteSolutionConfirmation from "Components/Classroom/ClassDialogs/CompleteSolutionConfirmation";
import CompleteSolution from "Components/Classroom/ClassDialogs/CompleteSolution";
import GetTextHelp from "Components/Classroom/ClassDialogs/GetTextHelp";
import GetVideoHelp from "Components/Classroom/ClassDialogs/GetVideoHelp";
import { useSelector } from "react-redux";


const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  "& .hintReq": {
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${theme.palette.border.blue}`,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "start",
  },
});

const Hint = ({ question, handleSubmit }) => {
  const [unlockSolutionConfirmation, setUnlockSolutionConfirmation] = useState(false);
  const [completeSolution, setCompleteSolution] = useState(false);
  const [getTextHelp, setGetTextHelp] = useState(false);
  const [getVideoHelp, setGetVideoHelp] = useState(false);

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <>
      <Grid2 sx={styles}>
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: theme.palette.background.default,
            padding: "8px",
            borderRadius: "8px",
            "& svg": {
              padding: "10px",
              background: theme.palette.white.main,
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
            },
          })}
        >
          <Typography
            color="secondary.light"
            display={"flex"}
            alignItems={"center"}
            gap="10px"
          >
            <PrimaryIcon
              height="18px"
              width="18px"
              color="secondary"
              icon={PlayIcon}
            />
            {Translation?.ProblemSolvingGuidelines}
          </Typography>
          <Button variant="outlined" color="secondary">
            {Translation?.WatchTutorial}
          </Button>
        </Box>
        <Typography color="secondary.light" fontWeight={500}>
          {Translation?.HintSupport}
        </Typography>
        {/* {(question?.CurrentAttempt < question?.TotalAttempt && !question?.IsSelectedOptionCorrect) && <>
            <Warning showAlert={false}>
              <Box display={"flex"} alignItems={"center"} gap="10px">
                <PrimaryIcon icon={SolutionIcon} />
                <Typography fontWeight={500} variant="title">
                  Complete Solution
                </Typography>
              </Box>
              <Box
                sx={{ marginLeft: "auto" }}
                display={"flex"}
                alignItems={"center"}
                gap={"10px"}
              >
                <Typography>50% points reduction</Typography>
                <Button
                  onClick={() => setUnlockSolutionConfirmation(true)}
                  color="white"
                  variant="contained"
                >
                  Unlock
                </Button>
              </Box>
            </Warning>
            <Typography variant="body2" color="secondary.light">
              Note :- Points get deducted only when you unlock complete solution
              - 50% Point Reduction
            </Typography>
        </>
        } */}
        <Typography variant="subtitle" fontWeight={500}>
          {Translation?.TeachingAssistantHelpRequest}
        </Typography>
        <Typography variant="subtitle" fontWeight={500}>
          {Translation?.AccessTAHelpRequests}
        </Typography>
        <Typography>
          {Translation?.Hint}: {question.Hint}
        </Typography>
        
        {/* <Typography>
          Solve problems on your own first. This will deepen your understanding
          of the topics and increase your confidence. Use the free hints
          provided by your instructors if you get stuck. TAs are here to help,
          but you'll learn best by trying to solve problems on your own. Hence,
          TA Help Requests will be accessible to you only after you use all the
          'free hints' available for the problem.
        </Typography> */}
        {/* <Typography variant="subtitle" fontWeight={500}>
          Which type of Help Request should I make and how?
        </Typography>
        <Grid2 container spacing={2}>
          <Grid2 size={5} className="hintReq">
            <Typography
              fontWeight={500}
              variant="subtitle"
              display={"flex"}
              gap={"10px"}
              alignItems={"center"}
            >
              Stuck while solving a problem ?
              <Chip color="warning" variant="filled" label="Text HR" />
            </Typography>
            <Typography color="secondary.light">
              Do this when you need help in Code Debugging or Questions that
              require minimal explanation format: Chat and comments
            </Typography>
            <Button
              onClick={() => setGetTextHelp(true)}
              variant="outlined"
              color="secondary"
            >
              Text Help Request
            </Button>
          </Grid2>
          <Grid2 size={5} className="hintReq">
            <Typography
              fontWeight={500}
              variant="subtitle"
              display={"flex"}
              gap={"10px"}
              alignItems={"center"}
            >
              Need help in understanding a topic ?
              <Chip variant="filled" label="Video call HR" />
            </Typography>
            <Typography color="secondary.light">
              Do this when you need to understand Topics or Questions in detail
              format: Video call on Scaler platform
            </Typography>
            <Button
              onClick={() => setGetVideoHelp(true)}
              variant="outlined"
              color="secondary"
            >
              Video Call Help Request
            </Button>
          </Grid2>
        </Grid2> */}
      </Grid2>
      {/* <CompleteSolutionConfirmation
        open={unlockSolutionConfirmation}
        setOpen={setUnlockSolutionConfirmation}
        handleUnlock={() => {
          setUnlockSolutionConfirmation(false);
          setCompleteSolution(true);
          // handleSubmit(false, true);
        }}
      />
      <CompleteSolution open={completeSolution} setOpen={setCompleteSolution} question={question} /> */}
      <GetTextHelp open={getTextHelp} setOpen={setGetTextHelp} />
      <GetVideoHelp open={getVideoHelp} setOpen={setGetVideoHelp} />
    </>
  );
};

export default Hint;
